import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  HeaderContainer,
  HeaderContent,
  Logo,
  Nav,
  NavList,
  NavItem,
  NavLink,
  MobileMenuButton,
  ContactInfo,
  ContactItem
} from '../styles/HeaderStyles';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActiveLink = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/">
          Cocoa-Pro Corporation
        </Logo>

        <Nav isOpen={isMobileMenuOpen}>
          <NavList>
            <NavItem>
              <NavLink to="/" className={isActiveLink('/')}>
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/about" className={isActiveLink('/about')}>
                About Us
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/services" className={isActiveLink('/services')}>
                Services
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/news" className={isActiveLink('/news')}>
                News Feed
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/team" className={isActiveLink('/team')}>
                Our Team
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/contact" className={isActiveLink('/contact')}>
                Contact Us
              </NavLink>
            </NavItem>
          </NavList>
        </Nav>

        <ContactInfo>
          <ContactItem>
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            +231-XXX-XXXX
          </ContactItem>
          <ContactItem>
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            info@cocoapro.com
          </ContactItem>
        </ContactInfo>

        <MobileMenuButton onClick={toggleMobileMenu}>
          ☰
        </MobileMenuButton>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
